export const DATA_LOADED = 'DATA_LOADED';
export const SET_USER = 'SET_USER';
export const ADD_TO_CART = 'ADD_TO_CART';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const REMOVE_ALL = 'REMOVE_ALL';
